import React from 'react'
import { mount, shallow } from 'enzyme'
import { MockedProvider } from "react-apollo/test-utils"
import Cell from '../Cell'

describe('<Cell />', () => {
  it('renders data if it is provided', () => {
    const wrapper = mount(<MockedProvider><Cell data={1000} /></MockedProvider>)
    expect(wrapper.text()).toEqual('1,000')
  })
  it('renders "-" when no data is provided', () => {
    const wrapper = mount(<MockedProvider><Cell /></MockedProvider>)
    expect(wrapper.text()).toEqual('')
  })
  it('renders an input if it is editable', () => {
    const wrapper = mount(<MockedProvider><Cell isEditable={true} /></MockedProvider>)
    expect(wrapper.find('input').length).toBe(1)
  })
  xit('it fires a mutation on blur if its data has changed', () => {
    // Unwrap graphql HOC to get to base component
    const wrapper = mount(<MockedProvider><Cell data={10000} isEditable={true} /></MockedProvider>)
    const input = wrapper.find('input')
    const newData = 5000
    wrapper.instance()._createValue = jest.fn()
    wrapper.update()
    input.simulate('blur')
    expect(wrapper.instance()._createValue.mock.calls.length).toBe(0)
    input.instance().value = newData
    input.simulate('blur')
    wrapper.update()
    expect(wrapper.instance()._createValue.mock.calls.length).toBe(1)
  })
  xit('sets its state to the new data value when a mutation is fired', () => {
    const wrapper = mount(<MockedProvider><Cell changeCell={jest.fn()} data={10000} isEditable={true} /></MockedProvider>)
    const input = wrapper.find('input')
    const newData = 5000
    wrapper.update()
    input.instance().value = newData
    input.simulate('blur')
    wrapper.update()
    expect(wrapper.state('data')).toEqual(newData)
  })
})
